// Mycart copy.js
// ~~~~~~~~~~~~~~~~~~~~~~~~~~ TIGMANSHU'S CODE ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

import $ from "jquery";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, Redirect } from "react-router-dom";
import { getLanguage } from "react-switch-lang";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Footer from "./Footer.js";
import Header from "./Header.js";
import Stepper from "./Stepper";
import EventTable from "./components/_EventTable";
import FixedBottomSummary from "./components/_FixedBottomSummary";
import MagazineTable from "./components/_MagazineTable";
import ProductTable from "./components/_ProductTable";
import * as myConstClass from "./constant.js";
import { BASE_URL, getProductCartCount, getCartDisplayCount } from "./constant.js";
import { routes } from "./routes.constants";
import {
  getCartTotalPriceAsync,
  resetMachineTestMode,
  selectCheckoutSteps,
  selectTotalPrice,
  setHasEvents,
  setHasProducts,
  setMachineTestSteps,
  stepsEnum,
} from "./store/checkoutSlice";
import "./yourCart.css";

const Mycart = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const checkoutSteps = useSelector(selectCheckoutSteps);
  const totalPrice = useSelector(selectTotalPrice);

  const [cartItems, setCartItems] = useState([]);
  const [eventItems, setEventItems] = useState([]);
  const [magazineItems, setMagazineItems] = useState([]);
  const [isCheckingStock, setIsCheckingStock] = useState(false);
  const [stockCheckResult, setStockCheckResult] = useState(null);
  const [isPreloadingStock, setIsPreloadingStock] = useState(false);

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (user_id) {
      localStorage.removeItem("error");
    }
    // Guest users can now view their cart without logging in
  }, [])

  useEffect(() => {
    // Check for machine tests and set appropriate steps
    const initializeCart = async () => {
      const fetchDataPromise = fetchData();
      await fetchDataPromise;
      
      // After fetching data, check if cart has machine tests
      const user_id = localStorage.getItem("user_id");
      let hasMachineTests = false;
      
      if (user_id && user_id > 0) {
        // Logged-in user: check backend
        const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
        const machineTestItemsData = await (await fetch(machineTestItemsUrl)).json();
        hasMachineTests = machineTestItemsData.length > 0;
      } else {
        // Guest user: check localStorage
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        hasMachineTests = guestEvents.some(event => event.event_type === 'Machine Test' || event.event_type_id === 3);
      }
      
      // Set appropriate steps based on cart contents
      if (hasMachineTests) {
        dispatch(setMachineTestSteps());
      } else {
    dispatch(resetMachineTestMode());
      }
      
    dispatch(getCartTotalPriceAsync());
    getCartItemsCount();
      
      setTimeout(() => {
        preloadStockStatus();
      }, 800); 
    };
    
    initializeCart();
  }, [dispatch]);

  // Mycart.js
  useEffect(() => {
    const user_id = localStorage.getItem('user_id');
    const guestAllowed = localStorage.getItem('guest_allowed') === 'true';

    if (!user_id && !guestAllowed) {
      // not allowed -> store return path and redirect to signin
      localStorage.setItem('redirect_after_login', window.location.pathname);
      history.replace('/signin');
      return;
    }

    // cleanup when leaving cart: revoke guest access so future entries force login
    // BUT: preserve flag if user is proceeding to checkout (not backing out)
    return () => {
      const isProceedingToCheckout = localStorage.getItem('cart_proceeding_to_checkout');
      
      // Only remove guest_allowed if user is backing out (not proceeding forward)
      if (!isProceedingToCheckout && localStorage.getItem('guest_allowed')) {
        localStorage.removeItem('guest_allowed');
      }
      
      // Clear the proceeding flag after checking
      if (isProceedingToCheckout) {
        localStorage.removeItem('cart_proceeding_to_checkout');
      }
    };
  }, []); // run on mount/unmount

  // Check for cart conflict message after login
  useEffect(() => {
    const conflictMessage = localStorage.getItem('cart_conflict_message');
    if (conflictMessage) {
      // Show the conflict warning on cart page
      setTimeout(() => {
        toast(conflictMessage, { 
          containerId: 'B', 
          type: toast.TYPE.ERROR, 
          autoClose: 8000
        });
      }, 500); // Small delay to ensure page is fully loaded
      
      // Clear the message so it doesn't show again
      localStorage.removeItem('cart_conflict_message');
    }
  }, []); // run once on mount

  useEffect(() => {
    
    if (cartItems.length > 0 && !isPreloadingStock && stockCheckResult !== null) {
      
      setStockCheckResult(null);
      
      preloadStockStatus();
    }
  }, [cartItems.length]); 
  async function getCartItemsCount() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: get count from backend
        const count = await getCartDisplayCount(user_id);
        $(".lblCartCount").html(count);
        if (+count === 0) {
          $("#ContinueToCheckoutMainDiv").css("display", "none");
        }
      } else {
        // Guest user: get count from localStorage
        const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
        const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        const totalCount = guestProducts.length + guestMagazines.length + guestEvents.length;
        
        $(".lblCartCount").html(totalCount);
        if (totalCount === 0) {
          $("#ContinueToCheckoutMainDiv").css("display", "none");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchProducts() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const produtsUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/${getLanguage()}`;
        const productsData = await (await fetch(produtsUrl)).json();

        if (productsData.length) {
          dispatch(setHasProducts(true));
        } else {
          dispatch(setHasProducts(false));
        }

        setCartItems(productsData);
        return productsData;
      } else {
        // Guest user: load from localStorage
        const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
        
        if (guestProducts.length) {
          dispatch(setHasProducts(true));
        } else {
          dispatch(setHasProducts(false));
        }
        
        setCartItems(guestProducts);
        return guestProducts;
      }
    } catch (error) {
      console.log("fetchProducts", error);
      return [];
    }
  }

  async function fetchEvents() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const eventItemsUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/${getLanguage()}`;
        const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;

        const [eventItemsData, machineTestItemsData] = await Promise.all([
          (await fetch(eventItemsUrl)).json(),
          (await fetch(machineTestItemsUrl)).json(),
        ]);

        if (eventItemsData.length + machineTestItemsData.length > 0) {
          dispatch(setHasEvents(true));
        } else {
          dispatch(setHasEvents(false));
        }

        setEventItems([...eventItemsData, ...machineTestItemsData]);
        return [...eventItemsData, ...machineTestItemsData];
      } else {
        // Guest user: load from localStorage and transform to expected structure
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        
        // Transform guest events to match backend structure with event grouping
        const transformedEvents = [];
        if (guestEvents.length > 0) {
          const groupedEvents = {};
          guestEvents.forEach(event => {
            const eventType = event.event_type || 'Event';
            if (!groupedEvents[eventType]) {
              groupedEvents[eventType] = {
                event_type: eventType,
                event_type_id: event.event_type_id || 1,
                arr_cart: []
              };
            }
            groupedEvents[eventType].arr_cart.push({
              event_id: event.event_id,
              schedule_id: event.schedule_id,
              title: event.title,
              parent: event.parent || 0,
              child: event.child || 0,
              first_price: event.price || 0,
              second_price: event.child_price || event.price || 0,
              venue_address: event.venue_address || '',
            });
          });
          transformedEvents.push(...Object.values(groupedEvents));
        }
        
        if (transformedEvents.length > 0) {
          dispatch(setHasEvents(true));
        } else {
          dispatch(setHasEvents(false));
        }
        
        setEventItems(transformedEvents);
        return transformedEvents;
      }
    } catch (error) {
      console.log("fetchEvents", error);
      return [];
    }
  }

  // Magazine fetching - magazines can coexist with products now
  async function fetchMagazines() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const magazinesUrl = `${BASE_URL}cart/getAllMyCartDataForMagazine/${user_id}/${getLanguage()}`;
        const magazinesData = await (await fetch(magazinesUrl)).json();

        setMagazineItems(magazinesData);
        return magazinesData;
      } else {
        // Guest user: load from localStorage and transform to expected structure
        const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
        
        // Transform to match backend structure
        const transformedMagazines = guestMagazines.map(mag => ({
          ...mag,
          magazine_title: mag.title,
          subscription_type: 'Guest Subscription',
          package_title: mag.package_title || 'Subscription Package',
          donation_contribution: mag.price || 0,
        }));
        
        setMagazineItems(transformedMagazines);
        return transformedMagazines;
      }
    } catch (error) {
      console.log("fetchMagazines", error);
      return [];
    }
  }

  async function fetchData() {
    try {
      const [events, products, magazines] = await Promise.all([
        fetchEvents(),
        fetchProducts(),
        fetchMagazines(),
      ]);
    } catch (error) {
      console.log("fetchData", error);
    }
  }


  async function preloadStockStatus() {
    try {
      setIsPreloadingStock(true);
      const result = await checkProductsStockInternal();
      setStockCheckResult(result);
      setIsPreloadingStock(false);
    } catch (error) {
      console.log("Error preloading stock status:", error);
      setIsPreloadingStock(false);
    }
  }


  async function checkProductsStockInternal() {
    try {
      const user_id = localStorage.getItem("user_id");
      const language = getLanguage();
      
      // Get cart products - fetch if state is empty
      let cartProducts = [];
      if (cartItems.length > 0) {
        
        cartProducts = cartItems;
      } else {
        
        if (user_id && user_id > 0) {
          const cartUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/${language}`;
          cartProducts = await (await fetch(cartUrl)).json();
        } else {
          cartProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
        }
      }
      
      if (cartProducts.length === 0) {
        return { allInStock: true, message: '' };
      }
      
      // Fetch all products to get stock status
      const productsUrl = `${BASE_URL}product/getProductsFrontEnd/${language}/0/0/0/0/${user_id || 0}`;
      const productsResponse = await fetch(productsUrl);
      const productsData = await productsResponse.json();
      
      // Build a map of product_id -> out_of_stock status
      const productStockMap = {};
      if (productsData && productsData.length > 0) {
        productsData.forEach(category => {
          if (category.arr_product && category.arr_product.length > 0) {
            category.arr_product.forEach(prod => {
              productStockMap[prod.product_id] = {
                out_of_stock: prod.out_of_stock,
                title: prod.title || prod.short_title
              };
            });
          }
        });
      }
      
      // Check which cart products are out of stock
      const outOfStockProducts = [];
      cartProducts.forEach(cartItem => {
        const productId = cartItem.product_id;
        if (productStockMap[productId] && productStockMap[productId].out_of_stock === '1') {
          outOfStockProducts.push(productStockMap[productId].title || cartItem.title);
        }
      });
      
      if (outOfStockProducts.length > 0) {
        const message = language === 'en' 
          ? `The following product(s) are out of stock: ${outOfStockProducts.join(', ')}. Please remove them from your cart to proceed.`
          : `खालील उत्पादने स्टॉकमध्ये नाहीत: ${outOfStockProducts.join(', ')}. पुढे जाण्यासाठी कृपया त्यांना तुमच्या कार्टमधून काढा.`;
        return { allInStock: false, message };
      }
      
      return { allInStock: true, message: '' };
    } catch (error) {
      console.log("Error checking product stock:", error);
      // In case of error, allow to proceed (don't block user)
      return { allInStock: true, message: '' };
    }
  }

  async function checkProductsStock() {
    if (stockCheckResult !== null) {
      return stockCheckResult;
    }
    return await checkProductsStockInternal();
  }

  const handleProceed = async () => {
    try {
      // Check if products are out of stock before proceeding
      if (cartItems.length > 0) {
        
        let outOfStockCheck = stockCheckResult;
        
        if (!outOfStockCheck) {
          setIsCheckingStock(true);
          outOfStockCheck = await checkProductsStockInternal();
          setIsCheckingStock(false);
        }
        
        if (!outOfStockCheck.allInStock) {
          toast(outOfStockCheck.message, { containerId: 'B', type: toast.TYPE.ERROR });
          return;
        }
      }
      
      // Mark that user is proceeding to checkout (not backing out)
      // This prevents cleanup from removing guest_allowed flag
      localStorage.setItem('cart_proceeding_to_checkout', 'true');
      
      // Guest users can now proceed to address page
      // Account will be created automatically at payment step using address details
      if (eventItems.length > 0) {
        // Allow guest users to proceed to eventDetails page
        // This flag will be checked by eventDetails page to allow guest checkout
        const user_id = localStorage.getItem('user_id');
        if (!user_id) {
          localStorage.setItem('guest_allowed', 'true');
        }
        history.push("/eventDetails");
      } else {
        history.push("/address");
      }
    } catch (error) {
      console.log("Error in handleProceed:", error);
      setIsCheckingStock(false);
    }
  };

  const handleClearCart = async () => {
    const user_id = localStorage.getItem("user_id");
    const language = getLanguage();

    let are_you_sure = "Are you sure?";
    let revert = "Do you want to remove all items from the cart?";
    let deleteConfirm = "Yes, clear cart!";
    let cancel = "Cancel";
    if (language === "ma") {
      are_you_sure = "तुम्हाला खात्री आहे?";
      revert = "तुम्ही कार्टमधील सर्व वस्तू/उपक्रम काढून टाकू इच्छिता?";
      deleteConfirm = "होय, कार्ट साफ करा";
      cancel = "नाही";
    }

    try {
      const result = await Swal.fire({
        title: are_you_sure,
        text: revert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: cancel,
        confirmButtonText: deleteConfirm,
      });

      if (!result.value) return null;

      if (user_id && user_id > 0) {
        // Logged-in user: call clearCart API
        const clearUrl = `${BASE_URL}cart/clearCart/${user_id}`;
        const clearResponse = await fetch(clearUrl);
        const clearData = await clearResponse.json();

        if (clearData.status === "true") {
          toast(clearData.message, {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });

          // Refresh all cart data
          setCartItems([]);
          setEventItems([]);
          setMagazineItems([]);
          dispatch(setHasProducts(false));
          dispatch(setHasEvents(false));
          dispatch(getCartTotalPriceAsync());
          getCartItemsCount();
        } else {
          toast(clearData.message || "Error clearing cart", {
            containerId: "B",
            type: toast.TYPE.ERROR,
          });
        }
      } else {
        // Guest user: clear localStorage
        localStorage.removeItem('guest_cart_products');
        localStorage.removeItem('guest_cart_magazines');
        localStorage.removeItem('guest_cart_events');
        localStorage.setItem('cartCount', 0);

        setCartItems([]);
        setEventItems([]);
        setMagazineItems([]);
        dispatch(setHasProducts(false));
        dispatch(setHasEvents(false));
        dispatch(getCartTotalPriceAsync());

        $(".lblCartCount").html(0);
        
        const successMsg = language === 'en' 
          ? 'All items removed from cart successfully'
          : 'कार्टमधील सर्व वस्तू यशस्वीरित्या काढल्या';
        
        toast(successMsg, {
          containerId: "B",
          type: toast.TYPE.SUCCESS,
        });
      }
    } catch (error) {
      console.log("Error clearing cart:", error);
      toast("Error clearing cart. Please try again.", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <Header />

      <div className="mt-4 pt-2 mt-sm-4 pt-sm-4 mt-md-4 pt-md-4 mt-xl-1">
        <Stepper steps={checkoutSteps} currentStep={stepsEnum[0]} />
      </div>
      <div className="container">
        <EventTable
          eventItems={eventItems}
          setEventItems={setEventItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
            getCartItemsCount();
          }}
        />

        <ProductTable
          cartItems={cartItems}
          setCartItems={setCartItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
            getCartItemsCount();
          }}
        />

        {/* MagazineTable - magazines can now be in cart */}
        <MagazineTable
          magazineItems={magazineItems}
          setMagazineItems={setMagazineItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
            getCartItemsCount();
          }}
        />
      </div>
      {/* Check for cartItems, eventItems, or magazineItems since all can be in cart now */}
      {(cartItems?.length > 0 || eventItems?.length > 0 || magazineItems?.length > 0) ? (
        <>
          <FixedBottomSummary
            totalPrice={totalPrice}
            leftContent={
              <button
                className="btn btn-outline-danger btn-sm px-2 py-1 d-inline-flex align-items-center"
                onClick={handleClearCart}
                style={{ 
                  borderWidth: '1px',
                  fontWeight: '500',
                  fontSize: '0.85rem'
                }}
              >
                <i className="fas fa-trash-alt mr-2"></i>
                {getLanguage() === 'en' ? 'Remove All Items' : 'सर्व वस्तू काढा'}
              </button>
            }
          >
            <div>
              <button
                className="w-100 btn py-2 proceed-button text-nowrap"
                onClick={handleProceed}
                disabled={isCheckingStock}
              >
                {isCheckingStock ? (
                  <>
                    <span className="mr-1 fw-bold">
                      {getLanguage() === 'en' 
                        ? 'Checking Stock Availability...' 
                        : 'स्टॉक उपलब्धता तपासत आहे...'}
                    </span>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <span className="mr-1 fw-bold">Next</span>{" "}
                    <i className="fas fa-chevron-right fw-bold"></i>
                  </>
                )}
              </button>
            </div>
          </FixedBottomSummary>
        </>
      ) : (
        <>
          <div className="container my-4 px-3 flex-wrap">
            Your Cart is Currently Empty. Add Some{" "}
            <Link to={routes.moreProducts}>Products</Link> and visit here to
            Checkout
          </div>
        </>
      )}
      <Footer />
    </>
  );
};

export default Mycart;
